import { assessmentSummaryConstants } from '../../_constants';

const initialState = { getBatchLoading: true, data: '', error: false };

export function getBatchAssessmentSummary(state = initialState, action) {
    
    switch (action.type) {
        case assessmentSummaryConstants.REQUEST_BATCH:
            return {
                getBatchLoading: true,
                data: '',
                error: false
            };
        case assessmentSummaryConstants.RECEIVE_BATCH:
            return {
                getBatchLoading: false,
                data: action.getBatch,
                error: false
            };
        case assessmentSummaryConstants.BATCH_ERROR:
            return {
                getBatchLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/assessmentSummary/getBatchList.reducer.js